import { BrowserRouter, Redirect, Route, Switch } from 'react-router-dom';
import { useAuth } from '../hooks/auth';
import Acessorios from '../pages/Acessorios';
import AcessoriosCreate from '../pages/AcessoriosCreate';
import Bombas from '../pages/Bombas';
import BombasCreate from '../pages/BombasCreate';
import Clientes from '../pages/Clientes';
import Configuracoes from '../pages/Configuracoes';
import CPP from '../pages/CPP';
import CPPCreate from '../pages/CPPCreate';
import Descontos from '../pages/Descontos';
import DescontosCreate from '../pages/DescontosCreate';
import DescontosInfo from '../pages/DescontosInfo';
import DescontosInfoCreate from '../pages/DescontosInfoCreate';
import Grupos from '../pages/Grupos';
import GruposCreate from '../pages/GruposCreate';
import Home from '../pages/Home';
import Modelos from '../pages/Modelos';
import ModelosCreate from '../pages/ModelosCreate';
import PrecosVariantes from '../pages/PrecosVariantes';
import PrecosVariantesCreate from '../pages/PrecosVariantesCreate';
import Propostas from '../pages/Propostas';
import PropostasAcessorios from '../pages/PropostasAcessorios';
import PropostasAcessoriosDummy from '../pages/PropostasAcessoriosDummy';
import PropostasAcessoriosModelo from '../pages/PropostasAcessoriosModelo';
import PropostasCreate from '../pages/PropostasCreate';
import PropostasDummy from '../pages/PropostasDummy';
import PropostasModelo from '../pages/PropostasModelo';
import Segmentos from '../pages/Segmentos';
import Subtipos from '../pages/Subtipos';
import Tabelas from '../pages/Tabelas';
import TabelasCreate from '../pages/TabelasCreate';
import Token from '../pages/Token';
import Usuarios from '../pages/Usuarios';
import UsuariosCreate from '../pages/UsuariosCreate';

function Routes() {

    const { data, loading } = useAuth();

    if (loading) {
        return null;
    }

    return (
        <BrowserRouter basename="/">
            {!data.token
                ?
                <Switch>
                    <Route exact={true} path="/token/:token" component={Token} />
                    <Route exact={true} path="*" component={Token} />
                </Switch>
                :
                <Switch>
                    <Route exact={true} path="/" render={() => <Redirect to="/propostas" />} />
                    <Route exact={true} path="/home" key="home" component={Home} />
                    <Route exact={true} path="/acessorios" key="acessorios/index" component={Acessorios} />
                    <Route exact={true} path="/acessorios/create" key="acessorios/create" component={AcessoriosCreate} />
                    <Route exact={true} path="/acessorios/:id" key="acessorios/show" component={AcessoriosCreate} />
                    <Route exact={true} path="/bombas" key="bombas/index" component={Bombas} />
                    <Route exact={true} path="/bombas/create" key="bombas/create" component={BombasCreate} />
                    <Route exact={true} path="/bombas/:id" key="bombas/show" component={BombasCreate} />
                    <Route exact={true} path="/clientes" key="clientes/index" component={Clientes} />
                    <Route exact={true} path="/configuracoes" key="configuracoes" component={Configuracoes} />
                    <Route exact={true} path="/cpp" key="cpp/index" component={CPP} />
                    <Route exact={true} path="/cpp/create" key="cpp/create" component={CPPCreate} />
                    <Route exact={true} path="/cpp/:id" key="cpp/show" component={CPPCreate} />
                    <Route exact={true} path="/descontos/cliente" key="descontos/cliente/index" component={Descontos} />
                    <Route exact={true} path="/descontos/cliente/:cliente" key="descontos/cliente/create" component={DescontosCreate} />
                    <Route exact={true} path="/descontos/info" key="descontos/info/index" component={DescontosInfo} />
                    <Route exact={true} path="/descontos/info/:segmento" key="descontos/info/create" component={DescontosInfoCreate} />
                    <Route exact={true} path="/grupos" key="grupos/index" component={Grupos} />
                    <Route exact={true} path="/grupos/create" key="grupos/create" component={GruposCreate} />
                    <Route exact={true} path="/grupos/:id" key="grupos/show" component={GruposCreate} />
                    <Route exact={true} path="/modelos" key="modelos/index" component={Modelos} />
                    <Route exact={true} path="/modelos/create" key="modelos/create" component={ModelosCreate} />
                    <Route exact={true} path="/modelos/:id" key="modelos/show" component={ModelosCreate} />
                    <Route exact={true} path="/precos/variantes" key="precos/variantes/index" component={PrecosVariantes} />
                    <Route exact={true} path="/precos/variantes/:id" key="precos/variantes/create" component={PrecosVariantesCreate} />
                    <Route exact={true} path="/propostas" key="propostas/index" component={Propostas} />
                    <Route exact={true} path="/propostas/create" key="propostas/create" component={PropostasCreate} />
                    <Route exact={true} path="/propostas/:id" key="propostas/show" component={PropostasCreate} />
                    <Route exact={true} path="/propostas/:id/modelo/:modelo" key="propostas/modelo" component={PropostasModelo} />
                    <Route exact={true} path="/propostas/:id/dummy/:modelo" key="propostas/dummy" component={PropostasDummy} />
                    <Route exact={true} path="/propostas/:id/modelo/:modelo/acessorios" key="propostas/acessorios/index" component={PropostasAcessorios} />
                    <Route exact={true} path="/propostas/:id/modelo/:modelo/acessorios/:acessorio" key="propostas/acessorios/show" component={PropostasAcessoriosModelo} />
                    <Route exact={true} path="/propostas/:id/modelo/:modelo/dummy/:acessorio" key="propostas/acessorios/dummy" component={PropostasAcessoriosDummy} />
                    <Route exact={true} path="/segmentos" key="segmentos/index" component={Segmentos} />
                    <Route exact={true} path="/subtipos" key="subtipos/index" component={Subtipos} />
                    <Route exact={true} path="/tabelas" key="tabelas/index" component={Tabelas} />
                    <Route exact={true} path="/tabelas/create" key="tabelas/create" component={TabelasCreate} />
                    <Route exact={true} path="/tabelas/:id" key="tabelas/show" component={TabelasCreate} />
                    <Route exact={true} path="/token/:token" key="token" render={() => <Redirect to="/propostas" />} />
                    <Route exact={true} path="/usuarios" key="usuarios/index" component={Usuarios} />
                    <Route exact={true} path="/usuarios/:id" key="usuarios/show" component={UsuariosCreate} />
                </Switch>
            }
        </BrowserRouter>
    );
}

export { Routes };

